import useConversationsStore from '@/store/ConversationsStore';
import {
  completedConversationsSelector,
  incompleteConversationsSelector,
  selectedTranscriptSelector,
  conversationsActionsSelector,
  conversationsUtilsSelector,
  completedTotalPagesSelector,
  incompleteTotalPagesSelector,
} from '@/selectors/conversations';

export const useCurrentConversations = () => {
  const completedConversations = useConversationsStore(completedConversationsSelector);
  const incompleteConversations = useConversationsStore(incompleteConversationsSelector);
  const selectedTranscript = useConversationsStore(selectedTranscriptSelector);
  const completedTotalPages = useConversationsStore(completedTotalPagesSelector);
  const incompleteTotalPages = useConversationsStore(incompleteTotalPagesSelector);
  const actions = useConversationsStore(conversationsActionsSelector);
  const utils = useConversationsStore(conversationsUtilsSelector);

  return {
    completedConversations,
    incompleteConversations,
    selectedTranscript,
    completedTotalPages,
    incompleteTotalPages,
    actions,
    utils,
  };
};
